import { FC } from "react";

interface ThemeIconSVGProps {
    className?: string;
}

const ThemeIconSVG: FC<ThemeIconSVGProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.54 8.10875L21.45 4.2L18.25 1L1.44995 17.8L4.64995 21L17.54 8.10875ZM17.54 8.10875L14.34 4.90875M3.94995 4.75V7.25M3.94995 7.25V9.75M3.94995 7.25H1.44995M3.94995 7.25H6.44995M15.2 16V18.5M15.2 18.5V21M15.2 18.5H12.7M15.2 18.5H17.7M6.44995 1H6.46245V1.0125H6.44995V1ZM8.94995 3.5H8.96245V3.5125H8.94995V3.5ZM11.45 1H11.4625V1.0125H11.45V1ZM21.45 11H21.4625V11.0125H21.45V11ZM18.95 13.5H18.9625V13.5125H18.95V13.5ZM21.45 16H21.4625V16.0125H21.45V16Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ThemeIconSVG;
